"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _model = require("./model");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  left: ", "px;\n  top: -50%;\n  width: 100%;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  left: ", "px;\n  width: ", "px;\n  top: -10px;\n  cursor: default;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var roomIcon = /*#__PURE__*/_react.default.createElement("svg", {
  className: "icon icon-sl",
  dangerouslySetInnerHTML: {
    __html: '<use xlink:href="img/sprite.svg#icon-discord"></use>'
  }
});

var camIcon = /*#__PURE__*/_react.default.createElement("svg", {
  className: "icon icon-cam",
  dangerouslySetInnerHTML: {
    __html: '<use xlink:href="img/sprite.svg#icon-cam"></use>'
  }
});

var EventContainer = _styledComponents.default.div(_templateObject(), function (_ref) {
  var position = _ref.position;
  return position;
}, function (_ref2) {
  var width = _ref2.width;
  return width;
});

var TrackContent = _styledComponents.default.div(_templateObject2(), function (_ref3) {
  var adjust = _ref3.adjust;
  return adjust;
});

var ePic = function ePic(pic) {
  var imageFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'jpg';
  return pic ? /*#__PURE__*/_react.default.createElement("div", {
    className: "time-track__pic"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: "https://media.graphcms.com/output=format:".concat(imageFormat, "/resize=fit:crop,height:72,width:72/").concat(pic)
  })) : null;
};

var eTitle = function eTitle(speaker, title) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "time-track__speaker"
  }, getTitleStr(speaker, title));
};

var getTitleStr = function getTitleStr(speaker, title) {
  return speaker ? "".concat(speaker, " \xAB\u200E").concat(title, "\xBB") : title;
};

var iSpeaker = function iSpeaker(name, place, title, text) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", {
    className: "track-tooltip__speaker"
  }, name, ", ", place), /*#__PURE__*/_react.default.createElement("p", {
    className: "track-tooltip__title"
  }, "\xAB\u200E", title, "\xBB"), /*#__PURE__*/_react.default.createElement("div", {
    className: "track-tooltip__desc",
    dangerouslySetInnerHTML: {
      __html: text
    }
  }));
};

var iLt = function iLt(title) {
  var lightningTalks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", {
    className: "track-tooltip__speaker"
  }, title), lightningTalks.map(function (lt, i) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "track-tooltip__sec",
      key: i
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "track-tooltip__title"
    }, lt.title, " - ", lt.name), /*#__PURE__*/_react.default.createElement("div", {
      className: "track-tooltip__desc",
      dangerouslySetInnerHTML: {
        __html: lt.text
      }
    }));
  }));
};

var Tooltip = function Tooltip(_ref4) {
  var children = _ref4.children,
      on = _ref4.on;
  return on ? /*#__PURE__*/_react.default.createElement("div", {
    className: "track-tooltip"
  }, children) : null;
};

var Talk = function Talk(_ref5) {
  var talk = _ref5.talk,
      onClick = _ref5.onClick;
  var pic = talk.pic,
      speaker = talk.speaker,
      title = talk.title,
      lightningTalks = talk.lightningTalks,
      text = talk.text,
      name = talk.name,
      place = talk.place;

  var handleClick = function handleClick() {
    onClick({
      date: '',
      track: ''
    });
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "time-track__item js-time",
    onClick: handleClick,
    title: !name && !lightningTalks ? getTitleStr(speaker, title) : '',
    style: {
      '--bgColor': talk.bgColor,
      width: '100%',
      cursor: 'pointer'
    }
  }, ePic(pic), eTitle(speaker, title), /*#__PURE__*/_react.default.createElement(Tooltip, {
    on: !!name
  }, iSpeaker(name, place, title, text)), /*#__PURE__*/_react.default.createElement(Tooltip, {
    on: !!lightningTalks
  }, iLt(title, lightningTalks)));
};

var QARoom = function QARoom(_ref6) {
  var talk = _ref6.talk,
      onClick = _ref6.onClick;

  var handleClick = function handleClick() {
    onClick({
      date: '',
      track: '',
      isQaEvent: true
    });
  };

  return /*#__PURE__*/_react.default.createElement("a", {
    onClick: handleClick,
    className: "time-track__link js-time",
    style: {
      '--bgColor': talk.bgColor,
      width: '100%'
    }
  }, "Q&A ", roomIcon);
};

var SpeakerRoom = function SpeakerRoom(_ref7) {
  var talk = _ref7.talk,
      onClick = _ref7.onClick;
  var pic = talk.pic,
      speaker = talk.speaker,
      title = talk.title,
      speakerRoomLink = talk.speakerRoomLink,
      type = talk.type;

  var handleClick = function handleClick() {
    var samePage = false;

    if (speakerRoomLink[0] === '#') {
      samePage = true;
    }

    var override = {};

    if (type === 'expo-room') {
      // TODO: passing empty data and track will make speakers room available during the whole event
      override = {
        date: '',
        track: '',
        time: '',
        duration: ''
      };
    }

    onClick(_objectSpread(_objectSpread({}, override), {}, {
      samePage: samePage
    }));
  };

  return /*#__PURE__*/_react.default.createElement("a", {
    onClick: handleClick,
    className: "time-track__link room js-time",
    style: {
      '--bgColor': talk.bgColor,
      width: '100%'
    }
  }, ePic(pic), eTitle(speaker, title));
};

var DiscussionRoom = function DiscussionRoom(_ref8) {
  var talk = _ref8.talk,
      onClick = _ref8.onClick;
  var pic = talk.pic,
      speaker = talk.speaker,
      title = talk.title;
  return /*#__PURE__*/_react.default.createElement("a", {
    onClick: onClick,
    className: "time-track__link discussion js-time",
    style: {
      '--bgColor': talk.bgColor,
      width: '100%'
    }
  }, ePic(pic, 'png'), eTitle(speaker, title), camIcon);
};

var TrackEvent = function TrackEvent(_ref9) {
  var event = _ref9.event,
      calcPosition = _ref9.calcPosition,
      onClick = _ref9.onClick,
      trackTitle = _ref9.trackTitle;
  var position = calcPosition(event);
  var width = (0, _model.calcWidth)(event.duration);

  var handleClick = function handleClick(info) {
    onClick(_objectSpread(_objectSpread(_objectSpread({}, event), info), {}, {
      trackTitle: trackTitle
    }));
  };

  if (event.qaLink || event.title.indexOf('Q&A') === 0) {
    return /*#__PURE__*/_react.default.createElement(EventContainer, {
      position: position,
      width: width
    }, /*#__PURE__*/_react.default.createElement(QARoom, {
      talk: event,
      onClick: handleClick
    }));
  }

  if (event.speakerRoomLink) {
    return /*#__PURE__*/_react.default.createElement(EventContainer, {
      position: position,
      width: width
    }, /*#__PURE__*/_react.default.createElement(SpeakerRoom, {
      talk: event,
      onClick: handleClick
    }));
  }

  if (event.discussionRoomLink) {
    return /*#__PURE__*/_react.default.createElement(EventContainer, {
      position: position,
      width: width
    }, /*#__PURE__*/_react.default.createElement(DiscussionRoom, {
      talk: event,
      onClick: handleClick
    }));
  }

  return /*#__PURE__*/_react.default.createElement(EventContainer, {
    position: position,
    width: width
  }, /*#__PURE__*/_react.default.createElement(Talk, {
    talk: event,
    onClick: handleClick
  }));
};

function Track(_ref10) {
  var track = _ref10.track,
      calcPosition = _ref10.calcPosition,
      onClick = _ref10.onClick;
  var list = track.list,
      title = track.title;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('time-track__track', {
      odd: track.odd
    }),
    style: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'flex-start'
    }
  }, /*#__PURE__*/_react.default.createElement(TrackContent, {
    adjust: 26
  }, list.map(function (evt, i) {
    return /*#__PURE__*/_react.default.createElement(TrackEvent, {
      key: i,
      event: evt,
      trackTitle: title,
      calcPosition: calcPosition,
      onClick: onClick
    });
  })));
}

var _default = Track;
exports.default = _default;